import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App'

installKeyboardViewportGuard()
void startApp()

function installKeyboardViewportGuard() {
  const viewport = window.visualViewport
  if (!viewport) {
    return
  }

  let scrollTimer = 0
  const keepFocusedFieldVisible = () => {
    window.clearTimeout(scrollTimer)
    scrollTimer = window.setTimeout(() => {
      const activeElement = document.activeElement
      if (
        !(
          activeElement instanceof HTMLInputElement ||
          activeElement instanceof HTMLTextAreaElement ||
          activeElement instanceof HTMLSelectElement
        )
      ) {
        return
      }

      const fieldBounds = activeElement.getBoundingClientRect()
      const visibleTop = viewport.offsetTop + 13
      const visibleBottom = viewport.offsetTop + viewport.height - 21
      if (
        fieldBounds.top < visibleTop ||
        fieldBounds.bottom > visibleBottom
      ) {
        activeElement.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
          inline: 'nearest',
        })
      }
    }, 77)
  }

  document.addEventListener('focusin', keepFocusedFieldVisible)
  viewport.addEventListener('resize', keepFocusedFieldVisible)
  viewport.addEventListener('scroll', keepFocusedFieldVisible)
}

async function startApp() {
  const removedOldWorker = await clearDevelopmentCaches()
  const reloadKey = 'card-vault-cache-refresh-v1'

  if (removedOldWorker && !window.sessionStorage.getItem(reloadKey)) {
    window.sessionStorage.setItem(reloadKey, 'done')
    window.location.reload()
    return
  }

  window.sessionStorage.removeItem(reloadKey)
  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <App />
    </StrictMode>,
  )
}

async function clearDevelopmentCaches(): Promise<boolean> {
  const serviceWorker = navigator.serviceWorker
  const cacheStorage = globalThis.caches
  let removedOldWorker = false

  await Promise.all([
    serviceWorker
      ?.getRegistrations()
      .then(async (registrations) => {
        removedOldWorker = registrations.length > 0
        await Promise.all(
          registrations.map((registration) => registration.unregister()),
        )
      })
      .catch(() => undefined),
    cacheStorage
      ?.keys()
      .then((keys) => Promise.all(keys.map((key) => cacheStorage.delete(key))))
      .catch(() => undefined),
  ])

  return removedOldWorker
}
